module.exports = "/_next/static/images/massachusetts-a32459fda9c64f131c1aa2bb49d0b79f.svg";